$(".houdiniForm").on("submit", function (e) {
    e.preventDefault();

    var form = this;

    if (!$(form).valid()) return;

    grecaptcha.ready(function () {
        grecaptcha.execute(RECAPTCHA_SITEKEY, { action: "formsubmit" })
            .then(function (token) {
                $("#recaptchaResponse").val(token);
                form.submit();
            });
    });
});
